import * as S from './styles';

export const TextArea = ({ ...props }) => {
  return (
    <S.Wrapper>
      <S.TextArea {...props} />
    </S.Wrapper>
  );
};
